<template>
  <hm-content title="活动列表">
    <div class="table-panel flex flex-between">
      <div>
        <el-button
          class="mr10"
          type="primary"
          plain
          size="small"
          @click="addActivity"
          >创建活动</el-button
        >
        <!-- <input
          type="text"
          class="url"
          :value="activityListUrl"
          ref="activityListUrl"
        />
        <el-button type="primary" plain size="small" @click="copyUrl"
          >复制活动列表地址</el-button
        > -->
      </div>
      <div>
        <el-date-picker
          v-model="applyDate"
          type="datetimerange"
          align="right"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="报名开始时间"
          end-placeholder="报名结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
          clearable
        ></el-date-picker>
        <el-select
          clearable
          v-model="actStatus"
          placeholder="活动状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="开启" value="1"></el-option>
          <el-option label="关闭" value="0"></el-option>
        </el-select>
        <el-select
          clearable
          v-model="activityLabel"
          placeholder="活动类型"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            :label="v.itemText"
            :value="v.itemValue"
            v-for="(v, i) in activityLabelList"
            :key="i"
          ></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="createBy"
          placeholder="输入创建人名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="actName"
          placeholder="输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="flex flex-between item-center">
        <div class="hm-radio-group">
          <el-radio-group v-model="timeStatus" size="small" @change="switchTab">
            <el-radio-button label="all"
              >全部({{ subActivityList.all }})</el-radio-button
            >
            <el-radio-button label="running"
              >进行中({{ subActivityList.running }})</el-radio-button
            >
            <el-radio-button label="notStart"
              >未开始({{ subActivityList.notStart }})</el-radio-button
            >
            <el-radio-button label="end"
              >已结束({{ subActivityList.end }})</el-radio-button
            >
          </el-radio-group>
        </div>
        <div>
          <el-button type="primary" size="small" @click="to"
            >预约订单列表</el-button
          >
        </div>
      </div>

      <el-table
        stripe
        border
        ref="table"
        :data="subActivityList.activityList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="actName"
          align="center"
          label="活动名称"
        >
          <template slot-scope="scope">
            <div class="table-status flex item-center">
              <span
                class="status success-bg"
                v-show="scope.row.timeStatus === 'running'"
              ></span>
              <span
                class="status gray-bg"
                v-show="scope.row.timeStatus === 'notStart'"
              ></span>
              <span
                class="status danger-bg"
                v-show="scope.row.timeStatus === 'end'"
              ></span>
              <span class="flex flex-1 flex-start">{{
                scope.row.actName
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="activityLabelName"
          label="活动类型"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="240px"
          prop="startDateFormat"
          label="活动日期"
        >
          <template slot-scope="scope">
            <span class="time">
              {{ scope.row.actStartTime.split(" ")[0] }}至{{
                scope.row.actEndTime.split(" ")[0]
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="300px"
          prop="applyTime"
          label="报名时间"
        >
          <template slot-scope="scope">
            <span class="time">
              {{ scope.row.applyStartTime }}至{{ scope.row.applyEndTime }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actSite"
          label="地点"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="suitPerson"
          label="适合人群"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="关联发券">
          <template slot-scope="scope">
            <div v-for="(v, i) in scope.row.couponTypes" :key="i">
              {{ v }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="mainImgUrl"
          align="center"
          label="活动主图"
        >
          <template slot-scope="scope">
            <img
              style="width: 100%"
              :src="scope.row.mainImgUrl"
              alt="活动主图"
            />
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="报名人数"
          prop="realApplyNum"
        >
          <template slot-scope="scope">
            {{ scope.row.realApplyNum }}/{{ scope.row.actMemberUpperLimit }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="创建人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="排序"
          prop="sort"
        >
          <template slot-scope="scope">
            <div @dblclick="changeEnddate(scope.$index, scope.row)">
              <el-tooltip
                class="item"
                effect="dark"
                content="双击修改"
                placement="top"
                :disabled="!scope.row.edit_enddate"
              >
                <span v-show="scope.row.edit_enddate" class="blue">{{
                  scope.row.sortNum
                }}</span>
              </el-tooltip>
              <el-input
                type="number"
                :ref="'enddateinput' + scope.$index"
                @blur="enddateblur(scope.$index, scope.row)"
                @keyup.enter.native="$event.target.blur"
                clearable
                v-show="!scope.row.edit_enddate"
                size="mini"
                style="width: 100%"
                v-model="scope.row.sortNum"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="状态"
          prop="actStatus"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.actStatus == 1" class="success">开启</span>
            <span v-if="scope.row.actStatus == 0" class="danger">关闭</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="200"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="查看" placement="top">
                <div class="pointer mr10" @click="toDetails(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="复制" placement="top">
                <button class="pointer mr10 no-bg" @click="copy(scope.row)">
                  <span class="hmicon icon-fuzhi blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip class="item" content="报名详情" placement="top">
                <div class="pointer mr10" @click="toReservitionList(scope.row)">
                  <span class="hmicon icon-chazhaobiaodanliebiao blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="活动二维码" placement="top">
                <div class="pointer mr10" @click="productQrcode(scope.row.id)">
                  <span class="hmicon icon-erweima primary"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="编辑" placement="top">
                <div
                  class="pointer mr10"
                  @click="edit(scope.row)"
                  v-show="scope.row.auditState !== 'audit_pass'"
                >
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <div
                  class="pointer mr10"
                  @click="remove(scope.row)"
                  v-show="
                    scope.row.auditState !== 'audit_pass' ||
                    (scope.row.auditState === 'audit_pass' &&
                      scope.row.enabledState === 'disabled')
                  "
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <hm-status />
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="subActivityList.activityList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>

    <el-dialog
      title="请用微信扫一扫"
      :visible.sync="qrcodeDialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img :src="activityCode" alt="二维码" />
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmStatus from "@/components/HmStatus";
import moment from "moment";
import { getLoginUser, getUserName } from "@/utils/auth";

// import { getLoginUser } from "@/utils/auth";
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: { HmStatus },
  data() {
    return {
      createBy: "",
      activityLabel: "",
      activityCode: "",
      activityLabelList: [],
      currentPage: 1,
      qrcodeDialogVisible: false,
      timeStatus: "all",
      pageSize: 10,
      isOutputing: false,
      applyDate: [],
      actStatus: "",
      actName: "",
      activityListUrl: "",
      singleUrl: "",
      editSortNum: "",
    };
  },
  created() {
    this.getParamsCookie();
    const echoParams = getCookie({ key: "EVENTLIST", type: "session" });
    if (echoParams) {
      for (let key in echoParams) {
        if (this.hasOwnProperty(key)) {
          this[key] = echoParams[key];
        }
      }
      if (echoParams.startDate && echoParams.endDate) {
        this.date = [
          new Date(echoParams.startDate),
          new Date(echoParams.endDate),
        ];
      }
      this.currentPage = echoParams.pageNo;
    }
  },
  async mounted() {
    const { result } = await this.$store.dispatch("queryActivityLabel");
    if (result && result.length) {
      this.activityLabelList = result;
    }
    this.queryList().then((res) => {
      this.activityListUrl = res.result.shareUrl;
    });
  },
  computed: mapGetters([
    "subActivityList",
    "subscribeActiveListCount",
    "allSubActivityList",
  ]),
  watch: {
    // "subActivityList.activityList.total": {
    //   handler(val) {
    //     if (
    //       val == (this.currentPage - 1) * this.pageSize &&
    //       this.pageTotal != 0
    //     ) {
    //       this.currentPage -= 1;
    //       this.queryList();
    //     }
    //   },
    //   deep: true
    // },
    // subActivityList(val) {
    // },
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    },
  },
  methods: {
    enddateblur(index, rowdata) {
      if (rowdata.sortNum === "" || rowdata.sortNum === this.editSortNum) {
        rowdata.sortNum = this.editSortNum;
        this.subActivityList.activityList.records = [
          ...this.subActivityList.activityList.records,
        ];
      } else {
        let params = {
          sortNum: rowdata.sortNum,
          id: rowdata.id,
        };
        this.$store.dispatch("editSortNum", params).then((res) => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.queryList();
          }
        });
      }
      this.subActivityList.activityList.records[index].edit_enddate =
        !this.subActivityList.activityList.records[index].edit_enddate;
    },
    changeEnddate(index, rowdata) {
      console.log("index: ", index);
      this.editSortNum = rowdata.sortNum;
      this.subActivityList.activityList.records[index].edit_enddate =
        !this.subActivityList.activityList.records[index].edit_enddate; //直接加key
      this.subActivityList.activityList.records = [
        ...this.subActivityList.activityList.records,
      ];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    to() {
      this.$router.push({
        name: "BookingOrderList",
      });
    },
    async productQrcode(id) {
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      let params = {
        path: `id=${id}`,
        storeCode: storeCode,
        createBy: userName,
        shareFunction: "营销中心-预约活动列表",
        shareFrom: "bg",
      };
      const url = await this.$store.dispatch("shareDataSaveV2", params);

      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path: `activity/reservation/activityDetails?saveUUID=${url.result}`,
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    copyUrl() {
      const input = this.$refs.activityListUrl;
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
    },
    toReservitionList(row) {
      this.$router.push({
        name: "ViewReservitionList",
        query: {
          id: row.id,
          actName: row.actName,
        },
      });
    },
    toDetails(row) {
      let couponTypes = JSON.stringify(row.couponTypes);
      this.$router.push({
        name: "EventDetails",
        query: {
          id: row.id,
          couponTypes,
        },
      });
    },
    edit(row) {
      this.$router.push({
        name: "EditEvent",
        query: {
          id: row.id,
        },
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel,
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then((res) => {
            let list = res.result.activityList.records;
            list.forEach((v) => {
              v.startDateFormat = `${v.actStartTime}至${v.actEndTime}`;
              v.applyTime = `${v.applyStartTime}至${v.applyEndTime}`;
              v.realApplyNum = `${v.realApplyNum}/${v.actMemberUpperLimit}`;
              if (v.actStatus === "1") {
                v.actStatus = "开启";
              } else {
                v.actStatus = "关闭";
              }

              // if (v.actCostMoney && !v.actCostIntegral) {
              //   v.cost = `${v.actCostMoney}元`;
              // } else if (v.actCostMoney && v.actCostIntegral) {
              //   v.cost = `${v.actCostMoney}元/${v.actCostIntegral}积分`;
              // } else if (v.actCostIntegral && !v.actCostMoney) {
              //   v.cost = `${v.actCostIntegral}积分`;
              // } else {
              //   v.cost = "免费";
              // }
            });
            const tHeader = this.$refs.table.columns
              .map(
                (o) =>
                  o.label !== "序号" &&
                  o.label !== "操作" &&
                  o.label !== "排序" &&
                  o.label
              )
              .filter((o) => o);

            let filterVal = [];

            console.log("表头", this.$refs.table.$children);
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map((o) => o._props.prop)
                .filter((o) => o);
            }
            // filterVal.push("couponTypes")
            let arr = filterVal.map((item) => {
              if (item == "sort") {
                console.log("找到");
                item = "couponTypes";
              }
              return item;
            });
            filterVal = arr;
            let newList = list.map((item) => {
              if (item.couponTypes === null) {
                console.log("当前优惠券未设置--->", item.couponTypes);
                item.couponTypes = "";
              }
              return item;
            });
            list = newList;
            console.log("导表前的数组", list, filterVal);
            //  {{ scope.row.realApplyNum }}/{{ scope.row.actMemberUpperLimit }}
            // const tHeader = [
            //   "活动名称",
            //   "活动日期",
            //   "报名时间",
            //   "地点",
            //   "报名人数",
            //   "适合人群",
            //   "主图",
            //   "状态"
            // ];
            // const filterVal = [
            //   "actName",
            //   "actDate",
            //   "applyDate",
            //   "actSite",
            //   "realApplyNums",
            //   "suitPerson",
            //   "mainImgUrl",
            //   "timeStatusFormat"
            // ];
            let data = this.formatJson(filterVal, list);
            for (let i = 0; i < data.length; i++) {
              let newData = data[i].map((item) => {
                if (typeof item == "object") {
                  item = item[0];
                }
                return item;
              });
              const queryArr = newData.splice(9, 1)[0];
              newData.splice(6, 0, queryArr);
              data[i] = newData;
            }
            console.log("看看导出表格格式", data);
            exportJsonToExcel(
              tHeader,
              data,
              "活动列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id,
        })
        .then(() => {
          this.queryList();
        });
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("delSubActivity", {
            id: row.id,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success",
              });
              this.currentPage = 1;
              this.queryList();
            }
          });
      });
    },
    addActivity() {
      this.$router.push({
        name: "AddEvent",
      });
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList(this.searchCondition.status);
    },
    queryList() {
      this.setParamsCookie();
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        actName: this.actName,
        activityLabel: this.activityLabel,
        createBy: this.createBy,
        actStatus: this.actStatus,
        timeStatus: this.timeStatus,
      };

      params.applyStartTime =
        this.applyDate && this.applyDate.length > 0 ? this.applyDate[0] : null;
      params.applyEndTime =
        this.applyDate && this.applyDate.length > 0 ? this.applyDate[1] : null;
      setCookie({
        key: "EVENTLIST",
        type: "session",
        data: params,
      });
      return this.$store.dispatch("subActivityList", params);
    },
    setParamsCookie() {
      let searchCondition = {
        applyDate: this.applyDate,
        actName: this.actName,
        actStatus: this.actStatus,
        timeStatus: this.timeStatus,
      };
      setCookie({
        key: "eventListParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "eventListParams", type: "session" });
      if (prams) {
        this.applyDate = prams.applyDate;
        this.actName = prams.actName;
        this.actStatus = prams.actStatus;
        this.timeStatus = prams.timeStatus;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList() {
      const params = {
        pageSize: 999999,
        pageNo: 1,
        actName: this.actName,
        actStatus: this.actStatus,
        timeStatus: this.timeStatus,
      };
      params.applyStartTime =
        this.applyDate && this.applyDate.length > 0 ? this.applyDate[0] : null;
      params.applyEndTime =
        this.applyDate && this.applyDate.length > 0 ? this.applyDate[1] : null;
      return this.$store.dispatch("allSubActivityList", params);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    copy(row) {
      this.$router.push({
        name: "AddEvent",
        query: {
          id: row.id,
          type: "copy",
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}

.url {
  width: 1px;
  opacity: 0;
  border: none;
}

.qrcode-wrapper {
  img {
    width: 100%;
  }
}
</style>
